import { AWSS3Image } from "./AWSS3Image.model";

export class MenuItemCatalogGroupModel {
  id: number;
  menu_item_id: number;
  name: string;
  priority: number;
  main_group: string;
  images: AWSS3Image[];


  constructor(
    id = 0,
    menu_item_id = 0,
    name = '',
    main_group = ''
  ) {
    this.id = id;
    this.menu_item_id = menu_item_id;
    this.name = name;
    this.main_group = main_group;
  }
}
